// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commands-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.commands-header {
  margin-bottom: 2rem;
}

.commands-header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.commands-header p {
  color: #b0b3c1;
  font-size: 1.1rem;
}

.alert {
  padding: 1rem 1.5rem;
  border-radius: 12px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.alert-info {
  background: rgba(88, 101, 242, 0.1);
  border: 1px solid rgba(88, 101, 242, 0.3);
  color: #5865F2;
}

.commands-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.5rem;
}

.command-card {
  background: rgba(26, 26, 46, 0.6);
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid rgba(88, 101, 242, 0.2);
  transition: all 0.3s ease;
}

.command-card:hover {
  border-color: rgba(88, 101, 242, 0.5);
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.command-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.command-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1 1;
}

.command-title h3 {
  font-size: 1.3rem;
  margin: 0;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
}

.status-badge.enabled {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.status-badge.disabled {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.toggle-btn {
  background: transparent;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  transition: all 0.2s;
}

.toggle-btn.enabled {
  color: #10b981;
}

.toggle-btn.disabled {
  color: #ef4444;
}

.toggle-btn:hover {
  transform: scale(1.1);
}

.command-description {
  color: #b0b3c1;
  margin-bottom: 1rem;
}

.command-meta {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #b0b3c1;
  font-size: 0.9rem;
}

.command-restrictions {
  background: rgba(88, 101, 242, 0.1);
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.command-restrictions p {
  color: #b0b3c1;
  font-size: 0.85rem;
  margin: 0.25rem 0;
}

.edit-btn {
  background-color: #5865F2;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 100%;
  justify-content: center;
}

.edit-btn:hover {
  background-color: #4752C4;
}

.command-edit-form {
  margin-top: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  color: #b0b3c1;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.form-group input {
  width: 100%;
  background: rgba(15, 15, 30, 0.5);
  border: 1px solid rgba(88, 101, 242, 0.2);
  color: #ffffff;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
}

.form-group input:focus {
  border-color: #5865F2;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.save-btn {
  background-color: #10b981;
  color: #ffffff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  flex: 1 1;
  justify-content: center;
  transition: all 0.3s ease;
}

.save-btn:hover {
  background-color: #059669;
}

.cancel-btn {
  background-color: #6b7280;
  color: #ffffff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  flex: 1 1;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background-color: #4b5563;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Commands.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAO;EACP,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".commands-container {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.commands-header {\n  margin-bottom: 2rem;\n}\n\n.commands-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.commands-header p {\n  color: #b0b3c1;\n  font-size: 1.1rem;\n}\n\n.alert {\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.alert-info {\n  background: rgba(88, 101, 242, 0.1);\n  border: 1px solid rgba(88, 101, 242, 0.3);\n  color: #5865F2;\n}\n\n.commands-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 1.5rem;\n}\n\n.command-card {\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n  transition: all 0.3s ease;\n}\n\n.command-card:hover {\n  border-color: rgba(88, 101, 242, 0.5);\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.command-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.command-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 1;\n}\n\n.command-title h3 {\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.status-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.status-badge.enabled {\n  background: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.status-badge.disabled {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.toggle-btn {\n  background: transparent;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.toggle-btn.enabled {\n  color: #10b981;\n}\n\n.toggle-btn.disabled {\n  color: #ef4444;\n}\n\n.toggle-btn:hover {\n  transform: scale(1.1);\n}\n\n.command-description {\n  color: #b0b3c1;\n  margin-bottom: 1rem;\n}\n\n.command-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #b0b3c1;\n  font-size: 0.9rem;\n}\n\n.command-restrictions {\n  background: rgba(88, 101, 242, 0.1);\n  padding: 0.75rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n}\n\n.command-restrictions p {\n  color: #b0b3c1;\n  font-size: 0.85rem;\n  margin: 0.25rem 0;\n}\n\n.edit-btn {\n  background-color: #5865F2;\n  color: #ffffff;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  width: 100%;\n  justify-content: center;\n}\n\n.edit-btn:hover {\n  background-color: #4752C4;\n}\n\n.command-edit-form {\n  margin-top: 1rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  color: #b0b3c1;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.form-group input {\n  width: 100%;\n  background: rgba(15, 15, 30, 0.5);\n  border: 1px solid rgba(88, 101, 242, 0.2);\n  color: #ffffff;\n  padding: 0.75rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  outline: none;\n}\n\n.form-group input:focus {\n  border-color: #5865F2;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.save-btn {\n  background-color: #10b981;\n  color: #ffffff;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  flex: 1;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.save-btn:hover {\n  background-color: #059669;\n}\n\n.cancel-btn {\n  background-color: #6b7280;\n  color: #ffffff;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  flex: 1;\n  transition: all 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background-color: #4b5563;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
